import React, { Component } from 'react'
import { Calendar, Table, Badge, Form, Collapse, Button, Input, Select, message, InputNumber, DatePicker, TimePicker, Checkbox, Avatar, Tooltip, Modal } from 'antd';
import { Link } from 'dva/router'
import { connect } from 'dva'
import moment from 'moment'
import { all, get, create } from '../../services/restApi'
import { getTotal } from '../../utils'
import config from '../../utils/config'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import TourNew from './tourNew'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const Option = Select.Option;
const ButtonGroup = Button.Group;

class Tour extends Component {

    constructor (props) {
        super(props);

        this.state = {
            activities: [],
            tours: [],
            tourNewVisible: false,
            newTourProps: {}
        };

        if (localStorage.getItem('currentHotel')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
    }


    /**
    * Inicialización
    */
    componentDidMount () {
        
        let query = {};

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta las categorías principales del hotel asignado al gerente o recepcionista
        all('Activity', {
            limit: 1000
        }).then((resp) => {
            this.setState({ activities: resp.results });
        })


        // Consulta los tours del mes actual
        this.getTours();
    }


    getTours (value) {

        if (!value) {
            this.setState({ tours: [] });
            value = new Date();
        }

        // Consulta los tours del mes actual
        all('Tour', {
            where: {
                date: {
                    $gte: {__type: 'Date', iso: new Date(moment(value).subtract(1, 'month').startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment(value).add(1, 'month').endOf('month').format()).toISOString()},
                }
            }, 
            include: 'activity,activity.category,createdBy',
            limit: 1000
        }).then((resp) => {

            let tours = this.state.tours.concat(resp.results);
            let uniq_tours = _.uniq(tours, function(i) { return i.objectId });

            this.setState({ tours: uniq_tours });
        });
    }


    getListData (value) {        

        let listData = _.filter(this.state.tours, function (i) { 

            // Devolvemos el objeto dependiendo a la periodicidad guardada
            return moment(i.date.iso).format('DD-MM-YYYY') === value.format('DD-MM-YYYY') ||
                (i.repeat && i.periodicity === 'Diariamente') ||
                (i.repeat && i.periodicity === 'Semanalmente' && moment(i.date.iso).day() === value.day()) ||
                (i.repeat && i.periodicity === 'Mensualmente' && moment(i.date.iso).date() === value.date()) ||
                (i.repeat && i.periodicity === 'Anualmente' && moment(i.date.iso).format('DD-MM') === value.format('DD-MM'));
        });

        _.map(listData, (i) => {
            // Verificamos si el día que se eligió se encuentra entre los días bloqueados
            let days_disabled = _.find(i.days_disabled, {date: value.format('DD-MM-YYYY')});
            days_disabled ? i.active = false : i.active = true;

            return i;
        });

        return listData;
    }

    dateCellRender (value) {
        const listData = this.getListData(value);

        return (
            <ul className="events">
                {
                    listData.map(item => (
                        <Link key={item.objectId} onClick={() => { this.setUpdate(item, value) }}>
                            <li className="item-calendar" style={{borderLeft: item.active ? '3px solid #00a854' : '3px solid red'}}>
                                <span>{item.activity.name}</span><br />
                            </li>
                        </Link>
                    ))
                }
            </ul>
        );
    }

    getMonthData (value) {
        if (value.month() === 8) {
            return 1394;
        }
    }

    monthCellRender(value) {
        const num = this.getMonthData(value);
        
        return num ? (
            <div className="notes-month">
                <section>{num}</section>
                <span>Backlog number</span>
            </div>
        ) : null;
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {

        let query = { name: {$regex: '(?i)' + value} };

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('TourCompany', {where: query}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectActivityChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }

    hadleCalendarChange (value) {
        this.getTours(value)
    }


    /**
    * Establece el acción para crear
    */
    setCreate (item) {
        this.setState({ newTourProps: {} });
        this.showModalNewTour();
    }


    /**
    * Establece el acción para editar
    */
    setUpdate (item, date) {
        this.setState({ 
            newTourProps: {
                tourId: item.objectId,
                date: date
            }
        });

        this.showModalNewTour();
    }


    /**
    * Muestra / Oculta el modal para nuevo ingreso
    */
    showModalNewTour () { this.setState({ tourNewVisible: true }); }
    hideModalNewTour () { 
        this.setState({ tourNewVisible: false }); 
        this.getTours();
    }


    /**
    * Registro
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {};
            data.activity = {__type: 'Pointer', className: 'Activity', objectId: values.activity.key};
            data.quota = values.quota;
            data.date = {__type: 'Date', iso: new Date(values.date).toISOString()};
            data.type = values.type.key;
            data.startHour = {__type: 'Date', iso: new Date(moment(values.startHour).startOf('hour').format()).toISOString()};
            data.endHour = {__type: 'Date', iso: new Date(moment(values.endHour).startOf('hour').format()).toISOString()};
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            values.active ? data.active = values.active : data.active = true;
            values.repeat ? data.repeat = true : data.repeat = false;

            if (data.repeat) 
                data.periodicity = values.periodicity.key;
            
            if (!this.props.activityId) {
                // CREA
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('Tour', data).then(resp => {

                    _.extend(data, resp);
                    data.activity = _.find(this.state.activities, {objectId: data.activity.objectId});
                    data.createdBy = this.props.app.user;

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el registro exitosamente');

                    this.getTours(data.date);

                    this.props.dispatch({type: 'tour/createSuccess', payload: data})
                    this.props.form.resetFields();

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                data.objectId = this.props.activityId;
                this.props.dispatch({type: 'tour/update', payload: data})
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const activity_options = this.state.activities.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        Actividades&nbsp;
                        <Button type='primary' className="pull-right">
                            <Link onClick={this.setCreate.bind(this)} className=""><Icon name="plus" /> Agregar nuevo tour</Link>
                        </Button>
                    </h1>
                </section>

                <section className="content text-center">
                    <div className="row">
                        <div className="col-md-12">
                            <Calendar mode="month" dateCellRender={this.dateCellRender.bind(this)} onPanelChange={this.hadleCalendarChange.bind(this)} onChange={this.hadleCalendarChange.bind(this)} />
                        </div>
                    </div>
                </section>

                <Modal
                    visible={this.state.tourNewVisible}
                    title="Tour"
                    onCancel={this.hideModalNewTour.bind(this)}
                    footer={[]} 
                >
                    {this.state.tourNewVisible
                        ? <TourNew {...this.state.newTourProps} />
                        : ''
                    }
                </Modal>
            </div>
        )
    }
}

export default connect(({tour, app}) => ({tour, app}))(Form.create()(Tour))


// WEBPACK FOOTER //
// ./src/components/tours/index.js